import { useEffect } from 'react';
import { Success } from './Notifications';
import { takePendingSuccessNotice } from './pendingSuccessNotice';

export function usePendingSuccessNotice(): void {
    useEffect(() => {
        const messageKey = takePendingSuccessNotice();
        if (messageKey != null) Success(messageKey);
    }, []);
}
